import { InvoiceBorrowFormContainer } from "../../../containers/borrowSystem/Invoice/InvoiceBorrowFormContainer";
export function InvoiceBorrowFormPage() {
      return (
          <InvoiceBorrowFormContainer/>
      );
  }